import { render } from "./OrderReceivedPage.vue?vue&type=template&id=ccd13d08&scoped=true"
import script from "./OrderReceivedPage.vue?vue&type=script&lang=js"
export * from "./OrderReceivedPage.vue?vue&type=script&lang=js"

import "./OrderReceivedPage.vue?vue&type=style&index=0&id=ccd13d08&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccd13d08"]])

export default __exports__